import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { deleteAccount, makePayment, generateLetter } from '../../API';
import { getCurrency, toggleOptionsMenu } from '../../Helper';
import YesNoModal from '../YesNoModal';

function AccountTable(props) {
    const [deleteAccountId, setDeleteAccountId] = useState(null);
    const [deletionConfirmationModal, setDeletionConfirmationModal] = useState(false);

    const toggleDeletionConfirmationModal = () => setDeletionConfirmationModal(!deletionConfirmationModal);
    const deleteRecord = async () => {
        if (deleteAccountId)
            await props.deleteRecord(deleteAccountId);
    };
    const cancelDelete = () => {
        setDeleteAccountId(null);
    };
    const setupDelete = (accountId) => {
        setDeleteAccountId(accountId);
        toggleDeletionConfirmationModal();
    };

    const tableBody = props.accounts.map(o => {
        const contactName = `${o.salutation ? o.salutation + ' ' : ''}${o.contactFirstName} ${o.contactLastName}`;
        const city = `${o.city}, ${o.state} ${o.zip}`;
        const active = o.isActive ? "Active" : "Inactive";

        const viewURL = '/admin/accounts/' + o.accountID;
        const editURL = '/admin/accounts/' + o.accountID + '/edit';
        const makePaymentURL = '/admin/makepayment?accountId=' + o.accountID;
        const letterURL = '/admin/letters?accountId=' + o.accountID;

        const createLetter = async (accountId) => {
            const generateLetterResult = await generateLetter(accountId);

            var file = window.URL.createObjectURL(generateLetterResult);
            window.open(file, '_blank');
        };

        return (
            <tr key={o.accountID}>
                <td>
                    <span>{active}</span>
                </td>
                <td>
                    <span>{o.accountNumber}</span>
                </td>
                <td>
                    <span>{o.name}</span>
                </td>
                <td>
                    <span>{contactName}</span>
                </td>
                <td>
                    <span className="full-address">
                        <span>{o.address}</span>
                        <span>{city}</span>
                    </span>
                </td>
                <td>
                    <span>{o.emailAddress}</span>
                </td>
                <td>
                    <span>{getCurrency(o.currentFeeBalance)}</span>
                </td>
                <td>
                    <div className="actions">
                        <Link to={viewURL} className="action-icon action-view">
                            <i className="fas fa-eye"></i>
                        </Link>
                        {window.env.user.userRoles.some(ur => [1, 2].includes(ur.roleID)) ? (
                            <Link to={editURL} className="action-icon action-edit">
                                <i className="fas fa-edit"></i>
                            </Link>
                        ) : null}
                        {window.env.user.userRoles.some(ur => [1, 2, 3, 4].includes(ur.roleID)) ? (
                            <div onClick={toggleOptionsMenu} className="action-icon action-dropdown">
                                <i className="fas fa-ellipsis-h"></i>
                                <div className="action-dropdown-menu">
                                    {window.env.user.userRoles.some(ur => [1, 4].includes(ur.roleID)) ? (
                                        <Link className="action-dropdown-menu-item" to={makePaymentURL}><div>Make Payment</div></Link>
                                    ) : null}
                                    {window.env.user.userRoles.some(ur => [1, 3].includes(ur.roleID)) ? (
                                        <Link className="action-dropdown-menu-item" to={letterURL}><span>Send Letter</span></Link>
                                    ) : null}
                                    {window.env.user.userRoles.some(ur => [1, 2].includes(ur.roleID)) ? (
                                        <div className="action-dropdown-menu-item" onClick={() => setupDelete(o.accountID)}><span>Delete</span></div>
                                    ) : null}
                                </div>
                            </div>
                        ) : null}
                    </div>
                </td>
            </tr>
        );
    });

    return (
        <div>
            <table className="table">
                <thead>
                    <tr>
                        <th>
                            <span>Active</span>
                        </th>
                        <th>
                            <span>Account Number</span>
                        </th>
                        <th>
                            <span>Account</span>
                        </th>
                        <th>
                            <span>Contact</span>
                        </th>
                        <th>
                            <span>Address</span>
                        </th>
                        <th>
                            <span>Email</span>
                        </th>
                        <th>
                            <span>Balance</span>
                        </th>
                        <th>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {tableBody}
                </tbody>
            </table>
            <YesNoModal title="Confirm Deletion" yesClick={deleteRecord} noClick={cancelDelete} open={deletionConfirmationModal} toggle={toggleDeletionConfirmationModal}>Are you sure you want delete this Account?</YesNoModal>
        </div>
    );
}

export default AccountTable;